import {
  useNavigate as useNavigateDefault,
  NavigateFunction,
  NavigateOptions,
  useLocation as RRDUseLocation,
} from 'react-router-dom'

const useNavigate = () => {
  const navigateDefault = useNavigateDefault()

  const navigate = ((path: string, options: NavigateOptions) =>
    navigateDefault(path, options)) as NavigateFunction

  return navigate
}

export const useLocation = RRDUseLocation

export default useNavigate
